<mat-card style="justify-content: center; align-items: center;">
    <mat-card-header>
        <div mat-card-avatar>

        </div>
        <mat-card-title></mat-card-title>
        <mat-card-subtitle></mat-card-subtitle>
    </mat-card-header>

    <mat-card-content
        style="display: flex; justify-content: center; align-items: center; flex-direction:column; text-align: center">
        <h1>New account setup</h1>
        <p></p>
        <br>

        <mat-stepper orientation="vertical" #stepper linear>
            <mat-step [stepControl]="registerFormGroup" [editable]="!verificationFormGroup.valid"
                [completed]="verificationFormGroup.valid">
                <ng-template matStepLabel>Request One Time Password</ng-template>
                <ng-template matStepContent>
                    <form [formGroup]="registerFormGroup" (ngSubmit)="registerFormGroup.valid && newStateMachine(1)">
                        <h4>How can we contact you?</h4>
                        <mat-form-field>
                            <mat-label>Email address</mat-label>
                            <input matInput placeholder="Your email address" formControlName="username" required>
                        </mat-form-field>
                    </form>
                    <h6>Data/SMS charges may apply</h6>
                    <button mat-button type="submit" (click)="newStateMachine(1)"
                        [disabled]="!registerFormGroup.valid">Request
                        verification code</button>
                </ng-template>
            </mat-step>
            <mat-step [stepControl]="verificationFormGroup" [editable]="!verificationFormGroup.valid"
                [completed]="verificationFormGroup.valid">
                <ng-template matStepLabel>Verification code</ng-template>
                <ng-template matStepContent>
                    <form [formGroup]="verificationFormGroup"
                        (ngSubmit)="verificationFormGroup.valid && !isValidating && newStateMachine(2)">
                        <h4>We send a verification code to: {{verificationFormGroup.value.username}}</h4>
                        <p>If not received after a minute or so, check your junk folder.</p>
                        <mat-form-field>
                            <mat-label>Your verification code</mat-label>
                            <input matInput placeholder="Your six digit verification code" formControlName="otp"
                                required>
                        </mat-form-field>
                    </form>
                    <h6>Verification code expires in: {{countDownMinutes}}:{{countDownSeconds}}</h6>
                    <button mat-button [disabled]="countDownMinutes>1 && isValidating" (click)="resend()">
                        Resend verification code</button>
                    <button mat-button type="submit" [disabled]="!verificationFormGroup.valid && !isValidating"
                        (click)="newStateMachine(2)">Verify
                        code</button>
                </ng-template>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Super Administrator setup</ng-template>
                <ng-template matStepContent>
                    <form [formGroup]="personalFormGroup"
                        (keydown.enter)="personalFormGroup.valid && newStateMachine(3)">
                        <mat-form-field>
                            <mat-label>First name</mat-label>
                            <input matInput placeholder="Your first name" formControlName="firstName" required>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Middle name</mat-label>
                            <input matInput placeholder="Middle name" formControlName="middleName">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Last name</mat-label>
                            <input matInput placeholder="Last name" formControlName="lastName" required>
                        </mat-form-field>
                        <br>
                        <mat-form-field>
                            <mat-label>Email address</mat-label>
                            <input matInput placeholder="email@domain" formControlName="email">
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>Phone number</mat-label>
                            <input matInput placeholder="(xxx) xxx-xxxx" formControlName="phoneNumber">
                        </mat-form-field>
                        <br>
                    </form>
                    <button mat-button type="submit" [disabled]="!personalFormGroup.valid"
                        (click)="newStateMachine(3)">Next</button>
                    <br>
                </ng-template>
            </mat-step>
            <mat-step>
                <ng-template matStepLabel>Login String</ng-template>
                <ng-template matStepContent>
                    @if(fqdn!=''){
                    <h4>Proceed to this URL:</h4>
                    <h3>https://{{fqdn}}/sitebuilder/?u={{personalFormGroup.value.username}}&p={{personalFormGroup.value.password}}
                    </h3>
                    <qrcode [qrdata]="loginString" [width]="256" [errorCorrectionLevel]="'H'"></qrcode>
                    }
                </ng-template>
            </mat-step>
        </mat-stepper>
    </mat-card-content>
</mat-card>